const ACCOUNT_DETAILS_LABEL_KEY = "accountdetails";
const ACCOUNT_HOME_LABEL_KEY = "accounthome";
const ADDRESS_BOOK_LABEL_KEY = "addressbook";
const BUSINESS_DETAILS_LABEL_KEY = "businessdetails";
const COMPONENT_NAME = "AccoundDrawer";
const COSTCO_PAY_LABEL_KEY = "costcopay";
const DIGITAL_MEMBERSHIP_CARD_LABEL_KEY = "digitalmembershipcard";
const LISTS_LABEL_KEY = "lists";
const MEMBERSHIP_CARD_ALT_TEXT_PREFIX = "membershipCardAltTextPrefix";
const MEMBERSHIP_CARD_IMAGE_TEST_ID = "accountdrawer-membergreeting-card-image";
const ORDERS_PURCHASES_LABEL_KEY = "orderspurchases";
const PAYMENT_METHODS_LABEL_KEY = "paymentmethods";
const PREFERENCES_LABEL_KEY = "preferences";
const RENEW_MEMBERSHIP_LABEL_KEY = "renewmembership";
const SIGN_OUT_LABEL_KEY = "signout";
const COSTCO_WALLET_LABEL_KEY = "costcowallet";
const ACCOUNT_NAV_DATA_TESTID = "Nav_accountNav";
const SIGN_IN_AND_SECURITY_LABEL_KEY = "signinandsecurity";
const ACCOUNT_PANEL_ARIA_LABEL_DEV_KEY = "accountPanelAriaLabel";
const CLOSE_BUTTON_ARIA_LABEL_DEV_KEY = "closeButtonAriaLabel";
export {
  ACCOUNT_DETAILS_LABEL_KEY,
  ACCOUNT_HOME_LABEL_KEY,
  ACCOUNT_NAV_DATA_TESTID,
  ACCOUNT_PANEL_ARIA_LABEL_DEV_KEY,
  ADDRESS_BOOK_LABEL_KEY,
  BUSINESS_DETAILS_LABEL_KEY,
  CLOSE_BUTTON_ARIA_LABEL_DEV_KEY,
  COMPONENT_NAME,
  COSTCO_PAY_LABEL_KEY,
  COSTCO_WALLET_LABEL_KEY,
  DIGITAL_MEMBERSHIP_CARD_LABEL_KEY,
  LISTS_LABEL_KEY,
  MEMBERSHIP_CARD_ALT_TEXT_PREFIX,
  MEMBERSHIP_CARD_IMAGE_TEST_ID,
  ORDERS_PURCHASES_LABEL_KEY,
  PAYMENT_METHODS_LABEL_KEY,
  PREFERENCES_LABEL_KEY,
  RENEW_MEMBERSHIP_LABEL_KEY,
  SIGN_IN_AND_SECURITY_LABEL_KEY,
  SIGN_OUT_LABEL_KEY
};
